module.exports = __webpack_public_path__ + "img/FeedCarrousel.6543df76.jpg";